module.exports = __webpack_public_path__ + "img/advantage-2.ad20006d.png";